var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content finance-interface" },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "span",
            {
              staticStyle: {
                position: "absolute",
                right: "10px",
                "margin-top": "5px",
                "z-index": "999"
              }
            },
            [
              _c(
                "el-link",
                {
                  attrs: { type: _vm.lbAccountType },
                  on: { click: _vm.selectAccountSetHandler }
                },
                [_vm._v(_vm._s(_vm.lbAccount))]
              )
            ],
            1
          ),
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { lazy: true, type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _vm.accountSet !== null &&
              _vm.$checkPermission(["tab_FinancialExchangeRateList"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_GroupExchangeRate"),
                        name: "financialExchangeRate"
                      }
                    },
                    [
                      _c("financial-exchange-rate-list", {
                        attrs: { "account-sets": _vm.accountSets }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_SobSetup"),
                    name: "accountSet"
                  }
                },
                [_c("ledger", { attrs: { "account-set": _vm.accountSet } })],
                1
              ),
              _vm.accountSet !== null &&
              _vm.$checkPermission(["tab_VoucherGroupingRule"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_VoucherGroupingRule"),
                        name: "accountingDocumentsRule"
                      }
                    },
                    [
                      _c("voucher-groupping-rule", {
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.accountSet !== null &&
              _vm.$checkPermission(["tab_EntryGroupingRule"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t(
                          "CargoMsg.Cargo_GroupingRulesOfJournalEntries"
                        ),
                        name: "accountingEntryRule"
                      }
                    },
                    [
                      _c("entry-groupping-rule", {
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.accountSet !== null &&
              _vm.$checkPermission(["tab_EntrySummaryMapping"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t(
                          "CargoMsg.Cargo_AbstractRuleOfJournalEntry"
                        ),
                        name: "entrySummaryRule"
                      }
                    },
                    [
                      _c("entry-summary-mapping", {
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.accountSet !== null &&
              _vm.$checkPermission(["tab_VoucherTypeMapping"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_VoucherLetter"),
                        name: "accountingDocumentType"
                      }
                    },
                    [
                      _c("voucher-type-mapping", {
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.accountSet !== null &&
              _vm.$checkPermission(["tab_EncodeMapping"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_CodingMapping"),
                        name: "financeCodeMapping"
                      }
                    },
                    [
                      _c("encode-mapping", {
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.accountSet !== null &&
              _vm.$checkPermission(["tab_TitleMapping"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_AccountTitleMapping"),
                        name: "entryAccountTitle"
                      }
                    },
                    [
                      _c("title-mapping", {
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.accountSet !== null &&
              _vm.$checkPermission(["tab_AccountTitleList"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_ConfigureAccountTitle"),
                        name: "accountTitle"
                      }
                    },
                    [
                      _c("account-title-list", {
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.accountSet !== null &&
              _vm.accountSet.softwareVersions === "WT" &&
              _vm.$checkPermission(["tab_AccountTitleBalanceList"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_InitialBalance"),
                        name: "accountTitleBalance"
                      }
                    },
                    [
                      _c("account-title-balance-list", {
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.accountSet !== null &&
              _vm.accountSet.softwareVersions === "WT" &&
              _vm.$checkPermission(["tab_FiscalPeriodList"])
                ? _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        lazy: true,
                        label: _vm.$t("CargoMsg.Cargo_FinancialPeriod"),
                        name: "fiscalPeriod"
                      }
                    },
                    [
                      _c("fiscal-period-list", {
                        attrs: {
                          "account-set": _vm.accountSet,
                          "account-sets": _vm.accountSets
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    lazy: true,
                    label: _vm.$t("CargoMsg.Cargo_VoucherLineNumberSetting"),
                    name: "voucherLineSetting"
                  }
                },
                [
                  _c("voucher-line-setting", {
                    attrs: { "account-set": _vm.accountSet }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("account-set-popup", {
        ref: "refAccountSetPopup",
        attrs: {
          visible: _vm.accountSetPopup.visible,
          mode: _vm.accountSetPopup.mode
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.accountSetPopup, "visible", $event)
          },
          select: function(data) {
            return (_vm.accountSet = data)
          },
          cancel: function() {
            return (_vm.accountSetPopup.visible = false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }